"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreEventManager = void 0;
const telemetry_1 = require("../../telemetry");
const interface_1 = require("./interface");
const eventManager_1 = require("./eventManager");
/**
 * Combines API and event manager to provide a service for listening to
 * core events. Core events are events that are not specific to any volume.
 * At this moment, Drive listenes only to shares with me updates from core
 * events. Such even indicates that user was invited to the new share or
 * that user's membership was removed from existing one and lost access.
 *
 * The client might be already using own core events, thus this service
 * is here only in case the client is not connected to the Proton services
 * with own implementation.
 */
class CoreEventManager {
    apiService;
    cache;
    manager;
    constructor(logger, apiService, cache) {
        this.apiService = apiService;
        this.cache = cache;
        this.apiService = apiService;
        this.manager = new eventManager_1.EventManager(new telemetry_1.LoggerWithPrefix(logger, `core`), () => this.getLastEventId(), (eventId) => this.apiService.getCoreEvents(eventId), (lastEventId) => this.cache.setLastEventId('core', {
            lastEventId,
            pollingIntervalInSeconds: this.manager.pollingIntervalInSeconds,
            isOwnVolume: false,
        }));
    }
    async getLastEventId() {
        const lastEventId = await this.cache.getLastEventId('core');
        if (lastEventId) {
            return lastEventId;
        }
        return this.apiService.getCoreLatestEventId();
    }
    async startSubscription() {
        await this.manager.start();
    }
    async stopSubscription() {
        await this.manager.stop();
    }
    addListener(callback) {
        this.manager.addListener(async (events, fullRefresh) => {
            if (events) {
                await callback(events);
            }
            if (fullRefresh) {
                // Because only updates about shares that are shared with me
                // are listened to from core events, in the case of core full
                // refresh, we don't have to refresh anything more than this
                // one specific event.
                await callback([{
                        type: interface_1.DriveEventType.ShareWithMeUpdated,
                    }]);
            }
        });
    }
}
exports.CoreEventManager = CoreEventManager;
//# sourceMappingURL=coreEventManager.js.map